module.exports = __webpack_public_path__ + "img/OVCA_Endothelial.7cc69a3a.png";